import type { ProviderConfig } from "../schema/provider.js";
import { registerCallbackProvider } from "./callback/index.js";
import type { SentryClientRegistry } from "./sentry/registry.js";
import type { ProviderInjectionContext, TelemetryProviderDefinition } from "./types.js";

export function isProviderDefinition(
  value: unknown,
): value is TelemetryProviderDefinition {
  return (
    typeof value === "object" &&
    value !== null &&
    "toProviderConfig" in value &&
    typeof (value as TelemetryProviderDefinition).toProviderConfig === "function"
  );
}

export function resolveProviderDefinitions(
  providers: TelemetryProviderDefinition[] | undefined,
  sentryRegistry: SentryClientRegistry,
): ProviderConfig[] | undefined {
  if (!providers?.length) {
    return undefined;
  }

  const injectionContext: ProviderInjectionContext = {
    sentryRegistry,
    registerCallback: registerCallbackProvider,
  };

  for (const definition of providers) {
    definition.inject?.(injectionContext);
  }

  return providers.flatMap((definition) => {
    const expandable = definition as TelemetryProviderDefinition & {
      toProviderConfigs?: () => ProviderConfig[];
    };
    if (typeof expandable.toProviderConfigs === "function") {
      return expandable.toProviderConfigs();
    }
    return [definition.toProviderConfig()];
  });
}
